(function ($) {
    $('.single-worker-block .open-worker-modal').on('click', function() {
        window.location.hash = 'worker-modal';
        $('.worker-modal').addClass('active');
        $('body').addClass('overflow-hidden');
    });

    $('.worker-modal.single-worker .close-button').on('click', function() {
        $('.worker-modal').removeClass('active');
        $('body').removeClass('overflow-hidden');
        window.history.pushState('', '/', window.location.pathname)
    })

    if (window.location.hash.includes("worker-modal")) {
        $('body').addClass('overflow-hidden');
        $('.worker-modal').addClass('active');
    }
})(jQuery);